module.exports = __webpack_public_path__ + "img/the-netherlands-cancer-male.cc57d89f.png";